import React, { useMemo } from 'react';

import { WalletConnectorIcons } from '../../assets/icons';
import Button from '../../components/Button';
import CustomModal from '../../components/CustomModal';
import CustomModalContent from '../../components/CustomModal/CustomModalContent';
import CustomModalHeader from '../../components/CustomModal/CustomModalHeader';
import { SupportedConnectors } from '../../config/constants';
import useConnectionState from '../../context/connection/useConnectionState';
import useModalState from '../../context/modal/useModalState';
import walletConnections, { ClosableWallet } from '../../web3/walletConnections';

const ConnectWalletModal: React.FC = () => {
    const { closeModal } = useModalState();
    const { activeConnector, activateWallet, disconnectWallet, handleDisconnect } =
        useConnectionState();

    const onClose = () => closeModal('connectWalletModal');

    const handleWalletClick = async (
        name: SupportedConnectors,
        connector: any | null
    ) => {
        activeConnector.name === name
            ? disconnectWallet()
            : activateWallet(name, connector);
    };

    const showDisconnect = useMemo(
        () => activeConnector.name && ClosableWallet.includes(activeConnector.name),
        [activeConnector.name]
    );

    return (
        <CustomModal modalName='connectWalletModal' className='connect-wallet-modal'>
            <CustomModalHeader title='Connect Wallet' onClose={onClose} />
            <CustomModalContent>
                <div className='wallet-connections'>
                    {Object.entries(walletConnections).map(([walletName, connector]) => (
                        <Button
                            key={walletName}
                            className={`card card-primary ${
                                walletName === activeConnector.name ? 'active' : undefined
                            }`}
                            onClick={() =>
                                handleWalletClick(
                                    walletName as SupportedConnectors,
                                    connector
                                )
                            }
                        >
                            <div className='icon-container'>
                                {WalletConnectorIcons[walletName as SupportedConnectors]}
                            </div>
                            <span className='wallet-name'>{walletName}</span>
                        </Button>
                    ))}
                    {/* <Button className='card card-primary' id='more-wallets'>
                        <span>
                            <span className='dot'></span>
                            <span className='dot'></span>
                            <span className='dot'></span>
                        </span>
                        More
                    </Button> */}
                </div>
                {showDisconnect && (
                    <Button id='disconnect-wallet' onClick={handleDisconnect}>
                        Disconnect
                    </Button>
                )}
            </CustomModalContent>
        </CustomModal>
    );
};

export default ConnectWalletModal;
